// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3aGiQ","insightsList":"newBusinessInsightsMenu_insightsList__Zq32X","active":"newBusinessInsightsMenu_active__3mgFI"};